
import { useAppBoot } from '../init/useAppBoot';
import { AppBootScreen } from '../init/AppBootScreen';

interface KeycloakProviderProps {
  children: React.ReactNode;
}

export const KeycloakProvider: React.FC<KeycloakProviderProps> = ({ children }) => {
  const { steps, ready } = useAppBoot();

  if (!ready) return <AppBootScreen steps={steps} />;

  return <>{children}</>;
};
